import { Box, Chip, useTheme } from '@mui/material';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import { valueToId } from 'utils/urlHashFilter';

import { TICKET_FILTERS_ALL } from 'restful/tickets';

import {
  MinimalIconButton,
  ShadowLeft,
  ShadowRight,
} from 'components/@common/HorizontalScroll/HorizontalScroll.styles';
import Icon from 'components/@icons/Icon';

interface Props {
  filters: Array<string>;
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}
// Copied and adapted from CategorySelector, if we need it in another place in the future, make this reusable
const TicketFilters = ({ activeFilter, filters, onFilterChange }: Props) => {
  const { direction } = useTheme();
  const boxRef = useRef<HTMLDivElement>(null);

  const allFilters = [TICKET_FILTERS_ALL, ...filters];

  const handleNext = () => {
    const scrollByLeft = direction === 'ltr' ? 150 : -150;
    boxRef.current?.scrollBy({
      left: scrollByLeft,
      behavior: 'smooth',
    });
  };

  const handlePrev = () => {
    const scrollByLeft = direction === 'ltr' ? -150 : 150;
    boxRef.current?.scrollBy({
      left: scrollByLeft,
      behavior: 'smooth',
    });
  };

  return (
    <Box sx={{ position: 'relative', mb: 3 }}>
      <ShadowLeft />
      <ShadowRight />

      <Box
        ref={boxRef}
        sx={{
          display: 'flex',
          gap: 1,
          flexDirection: 'row',
          position: 'relative',
          px: { xs: 2, md: 5 },
          minHeight: 32,
          overflowX: 'scroll',
          overflowY: 'hidden',
          scrollBehavior: 'smooth',

          // Added to remove scrollbar on FireFox
          scrollbarWidth: 'none',

          WebkitOverflowScrolling: 'touch',

          '::-webkit-scrollbar': {
            display: 'none',
          },

          scrollSnapType: 'x mandatory',
        }}
      >
        {allFilters.map((category) => {
          const isActive = activeFilter === category;
          return (
            <Chip
              key={category}
              id={valueToId(category)}
              label={
                category === TICKET_FILTERS_ALL ? (
                  <FormattedMessage id="event.tickets.filter.all" />
                ) : (
                  category
                )
              }
              variant={isActive ? 'filled' : 'outlined'}
              color={isActive ? 'secondary' : 'primary'}
              clickable
              onClick={() => onFilterChange(category)}
              size="small"
              sx={{
                height: 32,
                padding: '10px 16px 6px 16px',
              }}
            />
          );
        })}
      </Box>

      <MinimalIconButton
        sx={{
          top: 0,
          right: 0,
          display: { xs: 'none', md: 'flex' },
        }}
        onClick={handleNext}
      >
        <Icon name="ChevronRight" color="text.secondary" rotateInArabic />
      </MinimalIconButton>

      <MinimalIconButton
        sx={{
          top: 0,
          left: 0,
          display: { xs: 'none', md: 'flex' },
        }}
        onClick={handlePrev}
      >
        <Icon name="ChevronLeft" color="text.secondary" rotateInArabic />
      </MinimalIconButton>
    </Box>
  );
};

export default TicketFilters;
